import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { OrdersServices } from '../../kitchen/services';
import { PrintServices } from '../../services/printServices';
import { PrinterSunmiConfPage } from '../printer-sunmi-conf/printer-sunmi-conf';
import { PrinterSunmiQueuePage } from '../printer-sunmi-queue/printer-sunmi-queue';
import { PrinterSunmiInfoPage } from '../printer-sunmi-info/printer-sunmi-info';
import { TakeawayServices } from '../../takeaway/services';
import { NativeStorage } from '@ionic-native/native-storage';
import { OrdersCoServices } from '../../orders/services';
import { KitchenSectionsPage } from '../../components/popups/kitchen-sections/kitchen-sections';
import { TranslateService } from '@ngx-translate/core';




@Component({
  selector: 'page-printer-sunmi-auto',
  templateUrl: 'printer-sunmi-auto.html',
})
export class PrinterSunmiAutoPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    public printServices: PrintServices,
    public takeawayServices: TakeawayServices,
    public nativeStorage: NativeStorage,
    public ordersCoServices: OrdersCoServices,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public translate: TranslateService,
  ) {

  }
  onBack() {
    this.navCtrl.popToRoot();
  }

  openQueue() {
    this.navCtrl.push(PrinterSunmiQueuePage);
  }
  openConfig() {
    this.navCtrl.push(PrinterSunmiConfPage);
  }
  openInfo() {
    this.navCtrl.push(PrinterSunmiInfoPage);
  }

  async ionViewWillEnter() {
    //config
    this.printServices.configSetPrintSunmiAuto();
    //get list


    this.ordersServices.presentLoading();
    this.ordersServices.getShowType();
    await this.getNativeStorage();
    this.takeawayServices.getTables(this.globals.restaurant_uid);
    await this.ordersServices.getOrdersShow(this.globals.restaurant_uid);
    this.ordersServices.getOrdersHidden(this.globals.restaurant_uid, this.globals.user_uid);

    this.ordersServices.print_auto_on = true;


    //this.printServices.prepareOrderKitchen('order', order, order, this.globals.restaurant.printer_type, 'sections');


    /*this.ordersServices.getShowType();
    this.getNativeStorage();
    this.takeawayServices.getTables(this.globals.restaurant_uid);
    await this.ordersServices.getOrdersShow(this.globals.restaurant_uid);*/
  }

  async ionViewWillLeave() {
    //config anterior
    this.printServices.configResetPrintSunmiAuto();
    //limpar 
    //this.ordersServices.search_first_time = true;
    //this.ordersServices.observer_orders_print();//unsuscribe service
  }



  async getNativeStorage() {
    //Recuperamos los listados de tags y secciones para tener los activos
    this.nativeStorage.getItem('active_tags')
      .then(
        async value => {
          this.ordersCoServices.active_tags = await JSON.parse(value);

          await this.ordersCoServices.chargeElementsActiveTags();
        },
        async error => {
          await this.ordersCoServices.chargeElementsActiveTags();
        }
      );

    //creamos la estroctura de  name:TAG , active: true/false
    this.nativeStorage.getItem('active_sections')
      .then(
        async value => {

          if (value.length > 2) {
            this.ordersServices.select_show = await JSON.parse(value);
            //create array active_sections
            if (this.ordersServices.select_show[0].name != this.translate.instant('general-todos')) { //Si _active es undefined, lo ponemos en activo para que aparezca la order
              const confirm = this.alertCtrl.create({
                title: this.translate.instant('general-atencion'),
                message: this.translate.instant('kitchen-change-lang-alert'),
                buttons: [
                  {
                    text: this.translate.instant('general-aceptar'),
                    handler: () => {
                      this.ordersServices.change_language = true;
                      this.ordersServices.setSelectShow();
                      this.nativeStorage.setItem('active_sections', JSON.stringify([]));

                    }
                  },
                ]
              });
              confirm.present();
            }

            await this.ordersServices.setActiveSections();
          } else {
            await this.ordersServices.setSelectShow();
          }
        },
        error => { });
  }

  changeShowElements() {
    //abre modal donde enseñaremos las categorias y que seleccione lo que quiere que se muestre(los seleccionades estaran en array)
    let profileModal = this.modalCtrl.create(KitchenSectionsPage,
      {
        //title: this.translate.instant('general-selecciona-secciones-mostrar'),
        title: "Que mostrar en pantalla",
      });
    profileModal.onDidDismiss(data => {
    });
    profileModal.present();
  }

  back() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/printer-sunmi/printer-sunmi-auto/printer-sunmi-auto.ts